import { render, staticRenderFns } from "./Monitors.vue?vue&type=template&id=d58bc8f2&"
import script from "./Monitors.vue?vue&type=script&lang=js&"
export * from "./Monitors.vue?vue&type=script&lang=js&"
import style0 from "./Monitors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports